var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"flex-1 flex"},[_c('UserAuthForm',{attrs:{"submit-form":_vm.loginLocal,"button-text":"Login"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }